import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import ReportUserModal from '../ReportUserModal';
import PhotoZoomModal from '../PhotoZoomModal';

export default function GroupInfoModals({
  activeMemberCount,
  showLeaveModal,
  setShowLeaveModal,
  handleLeaveGroup,
  showReportModal,
  setShowReportModal,
  handleReportUserSubmit,
  showBlockModal,
  setShowBlockModal,
  handleBlockUser,
  setOpenActionsMemberId,
  postBlockReportUserId,
  setPostBlockReportUserId,
  showRemoveModal,
  setShowRemoveModal,
  handleConfirmRemoveMember,
  memberPhotoZoom,
  setMemberPhotoZoom,
}) {
  return (
    <>
      <Modal
        isOpen={showLeaveModal}
        onClose={() => setShowLeaveModal(false)}
        title="Leave Group?"
        size="md"
        closeOnVeil={false}
      >
        <ModalBody>
          <p className="text-ink/70">
            {activeMemberCount <= 1
              ? "Are you sure? You're the last member — leaving will close this group."
              : "Are you sure you want to leave this group? You'll be removed from this group."}
          </p>
        </ModalBody>
        <ModalFooter align="split">
          <Button variant="secondary" onClick={() => setShowLeaveModal(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleLeaveGroup}>
            Leave Group
          </Button>
        </ModalFooter>
      </Modal>

      <ReportUserModal
        open={!!showReportModal}
        onClose={() => setShowReportModal(null)}
        onSubmit={handleReportUserSubmit}
      />

      <Modal
        isOpen={!!showBlockModal}
        onClose={() => {
          setShowBlockModal(null);
          setOpenActionsMemberId(null);
        }}
        title="Block User?"
        size="md"
        closeOnVeil={false}
      >
        <ModalBody>
          <p className="text-ink/70">
            Blocking this user will hide their messages in this group and prevent you from being
            matched with them in future groups.
          </p>
        </ModalBody>
        <ModalFooter align="split">
          <Button
            variant="secondary"
            onClick={() => {
              setShowBlockModal(null);
              setOpenActionsMemberId(null);
            }}
          >
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleBlockUser}>
            Block User
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={!!postBlockReportUserId}
        onClose={() => setPostBlockReportUserId(null)}
        title="Do you also want to report this user?"
        size="md"
        closeOnVeil={false}
      >
        <ModalFooter align="split">
          <Button variant="secondary" onClick={() => setPostBlockReportUserId(null)}>
            No
          </Button>
          <Button
            onClick={() => {
              const uid = postBlockReportUserId;
              setPostBlockReportUserId(null);
              setShowReportModal(uid);
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={!!showRemoveModal}
        onClose={() => setShowRemoveModal(null)}
        title="Remove Member?"
        size="md"
        closeOnVeil={false}
      >
        <ModalBody>
          <p className="text-ink/70">
            Remove {showRemoveModal?.profile?.display_name || 'this member'} from the group? They
            will need manager approval to rejoin.
          </p>
        </ModalBody>
        <ModalFooter align="split">
          <Button variant="secondary" onClick={() => setShowRemoveModal(null)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirmRemoveMember}>
            Remove
          </Button>
        </ModalFooter>
      </Modal>

      <PhotoZoomModal
        open={!!memberPhotoZoom}
        onClose={() => setMemberPhotoZoom(null)}
        imageUrl={memberPhotoZoom?.url}
        alt={memberPhotoZoom?.alt}
      />
    </>
  );
}
